import React from 'react';
import Avatar from '@waglabs/avatar';
import { Box, } from '@waglabs/box-next';
import { Card, CardContent, } from '@waglabs/card';
import { StarIcon } from '@waglabs/icons';
import { Image } from '@waglabs/image-next';
import { Flex } from '@waglabs/flex-next';
import { Typography } from '@waglabs/typography';
import paw from '../../../../assets/paw-green-cropped.svg';
export const ReviewCarouselItem = ({ src, author, body, title, containerProps, }) => (React.createElement(Box, null,
    React.createElement(Avatar, { src: src, containerProps: {
            width: '100%',
            mb: '-40px',
            py: '8px',
        }, imageProps: {
            style: {
                border: '5px solid white',
            }
        } }),
    React.createElement(Card, Object.assign({ pb: 4, position: "relative", zIndex: -1, pt: ['40px'], m: "8px" }, containerProps),
        React.createElement(CardContent, { alignItems: "center", bg: "transparent" },
            React.createElement(Flex, { alignItems: "center", justifyContent: "space-between", mt: 1, width: 1 },
                React.createElement(Typography, { color: "wagBlue", fontFamily: "muliBold", fontSize: ['18px', null, '26px'], m: 0 }, title),
                React.createElement(Box, { textAlign: "right", width: "150px" }, [...Array(5)].map(() => (React.createElement(StarIcon, { height: "18px", width: "18px" }))))),
            React.createElement(Box, null,
                React.createElement(Typography, { color: "#474747", fontFamily: "muliSemiBold", fontSize: ['16px', null, '20px'], lineClamp: [5, 4] }, body),
                React.createElement(Typography, { color: "medGray", fontFamily: "muliSemiBold", mb: 0 }, `- ${author}`))),
        React.createElement(Image, { src: paw, position: "absolute", right: 0, bottom: 0 }))));
